<template>
	<v-menu
		ref="menu"
		v-model="menu"
		:close-on-content-click="false"
		transition="scale-transition"
		offset-y
		left
		min-width="auto"
		:disabled="readonly"
	>
		<template #activator="{ on, attrs }">
			<v-text-field
				:value="dateRangeText"
				v-bind="{ ...attrs, ...$attrs }"
				readonly
				v-on="on"
				@click:clear="save([])"
				@click:append="$emit('click:append')"
			></v-text-field>
		</template>
		<v-date-picker
			ref="picker"
			:value="value"
			:min="min"
			:max="max"
			range
			@input="save"
		></v-date-picker>
	</v-menu>
</template>

<script>
export default {
	props: {
		min: [String, Date],
		max: [String, Date],
		readonly: Boolean,
		value: {
			type: Array,
			default: () => [],
		},
	},

	data: () => ({
		menu: false,
	}),

	computed: {
		dateRangeText() {
			return this.value.join(" ~ ");
		},
	},

	methods: {
		save(dates) {
			dates = dates.sort();
			this.$emit("input", dates);
			if (dates[1]) this.$refs.menu.save(dates);
		},
	},
};
</script>
